import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import TopFlopTable from "./components/TopFlopTable";
import LineChartSection from "./components/LineChartSection";
import BubbleChartSection from "./components/BubbleChartSection";
import OverviewCard from "../../components/OverviewCard";
import MCalendar from "../../components/Kit/MCalendar";

import { getFinancialInsightsCallsOverviewData } from "../../utils/financialInsightsUtils";
import { initFinancialInsights } from "../../redux/actions/financialInsightsActions";
import { useAppContext } from "../../contexts/AppContext";

const FinancialInsights = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { financialDateRange, setFinancialDateRange } = useAppContext();
  const { calls } = useSelector((state) => state.analytics.analytics);
  const { sales_kpis, loading_sales_kpis } = useSelector(
    (state) => state.financial_insights.financial_insights
  );
  const { user } = useSelector((state) => state.user);
  const { scopes, loading: algoliaLoading } = useSelector((state) => state.algolia.algolia);
  const [overviews, setOverviews] = useState([]);

  const teamsScope = scopes?.teams || [];
  const departmentsScope = scopes?.departments || [];
  const localisationsScope = scopes?.localisations || [];
  // const hasGlobalVisibility = teamsScope.includes("all") || departmentsScope.includes("all") || localisationsScope.includes("all");
  const hasSimpleVisibility =
    teamsScope?.length === 0 && departmentsScope?.length === 0 && localisationsScope?.length === 0;

  useEffect(() => {
    dispatch(
      initFinancialInsights({
        start_date: financialDateRange.startDate,
        end_date: financialDateRange.endDate,
      })
    );
  }, [financialDateRange, user]);

  useEffect(() => {
    const overview_data = getFinancialInsightsCallsOverviewData(calls, sales_kpis);
    setOverviews(overview_data);
  }, [sales_kpis, calls]);

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 p-4 lg:p-6">
        {Object.values(overviews).map((overview) => (
          <div
            key={overview.description}
            className="col-span-1"
          >
            <OverviewCard
              overview={overview}
              loading={loading_sales_kpis}
            />
          </div>
        ))}
      </div>
      <div className="flex flex-wrap xl:flex-nowrap w-full gap-[20px] px-[20px]">
        <div className="bg-white rounded-md px-[32px] py-[20px] shadow-custom-light">
          <MCalendar
            dateRange={financialDateRange}
            setDateRange={(dates) => setFinancialDateRange(dates)}
            months={1}
          />
        </div>
        <div className="grow bg-white rounded-md px-[32px] py-[20px] overflow-hidden shadow-custom-light">
          <BubbleChartSection
            title="Representative map"
            subtitle="Numbers of calls (Y) - Average Sales (X)"
          />
        </div>
      </div>
      <div className="grid grid-cols-12 gap-[20px] p-[20px]">
        {!hasSimpleVisibility && (
          <div className="col-span-full xl:col-span-6 shadow-custom-light">
            <TopFlopTable department="ALL" />
          </div>
        )}
        <div
          className={`col-span-full shadow-custom-light ${
            hasSimpleVisibility ? "" : " xl:col-span-6 "
          }`}
        >
          <LineChartSection
            title="Revenues"
            subtitle="Company Revenues"
            data={calls}
          />
        </div>
      </div>
    </>
  );
};

export default FinancialInsights;
